
import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { LicenseInfo } from '@mui/x-license-pro';
import { initializeWithBeyonAuth } from 'utils/beyonAuth/beyonAuthInitialize'

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);

// Ensure root element exists
const rootElement = document.getElementById('root')
if (!rootElement) {
    throw new Error('Root element not found')
}

initializeWithBeyonAuth(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
